import {CountAmenityType} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenity.type";
import useCountAmenityValueGetter
    from "@CheckOrder/features/amenities/features/countAmenity/hooks/useCountAmenityValueGetter";
import roundToTwoDecimals from "@Number/roundToTwoDecimals";

/**
 * returns a function which sums up (display) prices from amenities array
 */
export default function useSumAmenities() {
    const {getCountAmenityValue} = useCountAmenityValueGetter()

    const sumAmenities = (countAmenities: CountAmenityType[] | null, direction: "single" | "return") => (
        roundToTwoDecimals(countAmenities.reduce((acc, countAmenity) => {
            return acc + countAmenity.priceInUserCurrency * getCountAmenityValue(countAmenity, direction)
        }, 0))
    )

    return {
        sumAmenities,
    }
}